<template>
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-3 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="id"
      />
      <span>Numéro</span>
    </div>
    <div class="elem elem--span-12 elem--sort">
      <BasicSort
        v-model="modelValue"
        name="dispositif"
      />
      <span>Dispositif</span>
    </div>


    <div class="elem elem--span-10">
      <span>Entreprise</span>
    </div>

    <div class="elem elem--span-4 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="statut"
      />
      <span>Etat</span>
    </div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
  </div>
</template>

<script setup lang="ts">
  const modelValue = defineModel<string>()
</script>
